import { Control } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Grid } from "@mui/material";
import { FormTextField, HeaderDivider } from "components";
import { CandidateDetailsFormData } from "../validation";

export const AddressDetails = ({
  control,
}: {
  control: Control<CandidateDetailsFormData>;
}) => {
  const { t } = useTranslation();
  return (
    <>
      <HeaderDivider text={t("details.addressTitle")} sx={{ mb: 3 }} />
      <Grid container spacing={2} sx={{ mb: 8 }}>
        <Grid size={{ xs: 12, md: 6 }}>
          <FormTextField
            name="address.street"
            label={t("details.street.label")}
            placeholder={t("details.street.placeholder")}
            control={control}
            required
          />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <FormTextField
            name="address.postalCode"
            label={t("details.postalCode.label")}
            placeholder={t("details.postalCode.placeholder")}
            control={control}
            required
          />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <FormTextField
            name="address.city"
            label={t("details.city.label")}
            placeholder={t("details.city.placeholder")}
            control={control}
            required
          />
        </Grid>
      </Grid>
    </>
  );
};
